export default __webpack_public_path__ + "static/media/img-slider-urban-fund-4.fd83efe0.png";